import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { Injectable } from "@angular/core";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { ICurrencyPairCalendarLookupService } from "../ICurrencyPairCalendarLookupService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class CurrencyPairCalendarLookupService
  extends BaseLookupService<string, CubiqTS.CurrencyPairCalendarImpl>
  implements ICurrencyPairCalendarLookupService
{
  public systemTradeDateRollover: CubiqTS.Moment = null;
  public previousTradeDataRollover: CubiqTS.Moment = null;

  constructor() {
    super(CubiqTS.CurrencyPairCalendarImpl);
  }

  public getItemKey(item: CubiqTS.CurrencyPairCalendarImpl): string {
    return item.baseCcy + item.nonBaseccy;
  }
}
